import { PureComponent, PropsWithChildren } from "react";

export default class InventoryFilterAdvancedFilterLabel extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-inventory-filter__adv-filter-label">
        {this.props.children}
      </div>
    );
  }
}
